<div [id]="fieldName+'divGanttchartContainer'+key" class="form-group label-static">
	<mat-label class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} control-label"
             [title]="componentDefinition?.label">
    {{componentDefinition?.label}}
    </mat-label>
	<div #elemChart class="sc-gantt-chart"></div>
	
</div>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>